import React, { useState, useEffect, useCallback, useRef, useContext } from "react";
import SideBar from "../components/sideBar";
import IgniteGrid from "../components/igniteGrid";
import './styles.css'
import Alert from "../components/alert";
import Multiselect from "multiselect-react-dropdown";
import { getVehicleReports } from "../api/getReports";
import CommonModal from "../components/modal";
import GetUsersList from "../api/getUserList";
import GetUserDevices from "../api/getUserDevices";
import GetModal from "../api/getModal";
import GetLotHistory from "../api/getOtherReports";
import GetHeaderType from "../api/getHeaderType";
import GridSettings from "../api/getGridSettings";
import BeaconOps from "../api/beaconOps";
import DataTransformer from "../utils/dataTransformer";
import { ReportTypeContext } from "../utils/reportTypeContext";
import { useRoleContext } from "../utils/roleContext";
import { Store, setGridData } from "../utils/store";
import { GetFileNames } from "../api/getInvoiceAPI";
import { GetVinNotes } from "../api/getVinNotes";
import GetContextReport from "../api/getContextReports";
import { GETAccessoryList } from "../api/accessoryAPI";
import { useSearch } from "../context/searchContext";
import { searchAPI } from "../api/searchApi";
import { GetDealerships } from "../api/getDataAPI";
import { GetScanHistory } from "../api/getApi";

export interface SidebarToggle {
    (collapsed: boolean): void;
}

export interface SidebarMenuSelected {
    (selected: string): void;
}

export interface AlertsData {
    (errCode: number, errMsg: string, status: string): void;
}

export interface HideData {
    (data: { key: string, hidden: boolean }): void;
}

const Dashboard = () => {
    const [data, setData] = useState<Record<string, any>[]>([])
    const [collapsed, setCollapsed] = useState(false);
    const [reportType1, setReportType1] = useState('');
    const [modal, setModal] = useState(false);
    const [title, setTitle] = useState('');
    const alreadyFetched = useRef(false);
    const [errorCode, setErrorCode] = useState<number>();
    const [errorMessage, setErrorMessage] = useState('');
    const [gridOperations, setGridOperations] = useState<string | null>();
    const [inventoryDate, setInventoryDate] = useState<string | null>();
    const [hiddenFields, setHiddenFields] = useState<string[]>([]);
    const [visibleFields, setVisibleFields] = useState<string[]>([]);
    const [hiddenData, setHiddenData] = useState<object>({});
    const [widthData, setWidthData] = useState<object>([]);
    const [showAddButton, setShowAddButton] = useState<boolean>(false);
    const [dealerships, setDealerships] = useState<{ dealerID: string, dealershipName: string }[]>([]);
    const [selectedTemporaryDealership, setSelectedTemporaryDealership] = useState<{ dealerID: string; dealershipName: string }[]>([]);
    const [selectedDealership, setSelectedDealership] = useState<{ dealerID: string; dealershipName: string }[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isSearchData, setIsSearchData] = useState<boolean>(false);
    const { reportType } = useContext(ReportTypeContext) || {};
    const { userRole } = useRoleContext();
    const hasFetchedAllVehicles = useRef(false);
    let Did = sessionStorage.getItem('dealerId');
    let userName = sessionStorage.getItem('userName');
    let vins = sessionStorage.getItem('vin');
    const { searchTerm, clearSearchTerm } = useSearch();

    const fetchData = useCallback(async (report: any) => {
        setGridOperations('')
        setData([]);

        try {
            alreadyFetched.current = true;
            if (!isLoading) {
                setIsLoading(true);
            }
            if (userRole === "Director" || userRole === 'Admin' || userRole === 'SuperUser') {
                const isDealershipEmpty = !selectedDealership ||
                    (Array.isArray(selectedDealership) && selectedDealership.length === 0);

                if (isDealershipEmpty && Did?.startsWith('-') && parseInt(Did) < 0) {
                    return;
                }
            }

            if (Did && userName) {
                if (report === "lotHistory") {
                    let res = await GetLotHistory(report, Did);
                    if (!res) return;
                    const transformedArray = res.map((item: any) => {
                        return {
                            "Print": "",
                            ...item,
                        }
                    })
                    setData(transformedArray)
                } else if (report === "scannedVehicleNotes") {
                    let res = await GetLotHistory(report, Did);
                    if (!res) return;
                    const transformedArray = res.map((item: any) => {
                        return {
                            ...item,
                        }
                    })
                    setData(transformedArray)
                } else if (report === "Extra Vehicles") {
                    let res = await GetLotHistory(report, Did);
                    if (!res) return;
                    const transformedArray = res.map((item: any, index: number) => {
                        return {
                            "id": index + 1,
                            "add": "",
                            ...item,
                        }
                    })
                    if (transformedArray.length === 0) {
                        transformedArray.push({
                            "id": transformedArray.length + 1,
                            "add": '',
                            "scanId": '',
                            "vin": '',
                            "scannedDate": '',
                            "stockNo": '',
                            "updateStatus": '',
                            "status": '',
                            "scannedLotLocation": '',
                            "color": '',
                            "vehicleStatus": '',
                            "lastknownlocation": ''
                        })
                    }
                    setData(transformedArray)
                } else if (report === "beaconVehiclesReport") {
                    let transformedArray: { [key: string]: any }[] = [];
                    let keyList: string[] = ["beaconIDForVehicles", "vehicleStatus", "stockNo", "vin", "modelYear", "make", "body", "type", "trimLevel", "color", "miles", "arrivalDate", "age", "retailPrice", "lotLocation", "scannedLotLocation", "lastScanned", "qrScannedCount"]
                    let resbeaconVehicleReport = await getVehicleReports('All Vehicles', parseInt(Did), false);
                    if (!resbeaconVehicleReport) return;
                    const transformedArraySub = resbeaconVehicleReport.map((item: { gpsEnable: any; scanned: any; scannedDate: any; scannedLotLocation: any; vehicleStatus: any; vehicles: any; }) => {
                        const { scannedLotLocation, vehicleStatus, vehicles } = item;
                        return {
                            scannedLotLocation,
                            vehicleStatus,
                            ...vehicles,
                        }
                    })
                    transformedArray = DataTransformer('vehicleBeacon', transformedArraySub, keyList)
                    setData(transformedArray)
                } else if (report === 'beaconKeysReport') {
                    let transformedArray: { [key: string]: any }[] = [];
                    let keyList: string[] = ["beaconID1ForKeys", "beaconID2ForKeys", "vehicleStatus", "stockNo", "vin", "modelYear", "make", "body", "type", "trimLevel", "color", "miles", "arrivalDate", "age", "retailPrice", "lotLocation", "scannedLotLocation", "lastScanned", "qrScannedCount"]
                    let resbeaconKeysReport = await getVehicleReports('All Vehicles', parseInt(Did), false);
                    if (!resbeaconKeysReport) return;
                    const transformedArraySub = resbeaconKeysReport.map((item: { gpsEnable: any; scanned: any; scannedDate: any; scannedLotLocation: any; vehicleStatus: any; vehicles: any; }) => {
                        const { scannedLotLocation, vehicleStatus, vehicles } = item;
                        return {
                            scannedLotLocation,
                            vehicleStatus,
                            ...vehicles,
                        }
                    })
                    transformedArray = DataTransformer('keyBeacon', transformedArraySub, keyList)
                    setData(transformedArray)
                } else if (report === 'getBeaconKeys') {
                    let resBeaconKeys = await BeaconOps('get', 'keys', parseInt(Did), '');
                    if (!resBeaconKeys) return;
                    let KeyList = ["id", "beaconID1ForKeys", "beaconID2ForKeys", "vin"]
                    let transformedArray = DataTransformer('beaconKeyDisplay', resBeaconKeys, KeyList)
                    setData(transformedArray)
                } else if (report === 'getBeaconVehicles') {
                    let resBeaconVehicles = await BeaconOps('get', 'vehicles', parseInt(Did), '');
                } else if (report === 'accessory') {
                    let resAccessory = await GETAccessoryList(Did)
                    if (resAccessory.length === 0) {
                        resAccessory.push({
                            "name": "",
                            "description": "",
                            "accessoryPrice": "",
                            "type": ""
                        })
                    }
                    setData(resAccessory)
                } else {
                    let resMain = await getVehicleReports("", Did, true);
                    if (resMain.length === 0) {
                        return;
                    }
                    let resFileNames = await GetFileNames(Did);
                    sessionStorage.setItem("fileNames", resFileNames)
                    let arr1: any[] = []
                    let resGridSettings = await GridSettings(userName);
                    if (resGridSettings !== "Error") {
                        resGridSettings = JSON.parse(resGridSettings);
                        const ageFieldExists = resGridSettings.some((element: any) => element.field === "age");
                        const transmittedExists = resGridSettings.some((element: any) => element.field === "transmitted");
                        const statusExists = resGridSettings.some((element: any) => element.field === "status");
                        const dealershipNameExists = resGridSettings.some((element: any) => element.field === "dealershipName");
                        // If age doesn't exist, add it to resGridSettings
                        if (!ageFieldExists) {
                            const ageObject = {
                                pinned: false,
                                sortable: true,
                                filterable: true,
                                editable: false,
                                sortingIgnoreCase: true,
                                filteringIgnoreCase: true,
                                headerClasses: "",
                                headerGroupClasses: "",
                                groupable: false,
                                movable: true,
                                hidden: false,
                                dataType: "string",
                                hasSummary: false,
                                field: "age",
                                width: "150px",
                                header: "age",
                                resizable: true,
                                searchable: true,
                                selectable: true,
                                parent: null,
                                columnGroup: false,
                                disableHiding: false
                            };

                            resGridSettings.push(ageObject);
                        }

                        if (!transmittedExists) {
                            const transObj = {
                                pinned: false,
                                sortable: true,
                                filterable: true,
                                editable: false,
                                sortingIgnoreCase: true,
                                filteringIgnoreCase: true,
                                headerClasses: "",
                                headerGroupClasses: "",
                                groupable: false,
                                movable: true,
                                hidden: false,
                                dataType: "boolean",
                                hasSummary: false,
                                field: "transmitted",
                                width: "150px",
                                header: "transmitted",
                                resizable: true,
                                searchable: true,
                                selectable: true,
                                parent: null,
                                columnGroup: false,
                                disableHiding: false
                            };

                            resGridSettings.push(transObj);
                        }

                        if (!statusExists) {
                            const transObj = {
                                pinned: false,
                                sortable: true,
                                filterable: true,
                                editable: false,
                                sortingIgnoreCase: true,
                                filteringIgnoreCase: true,
                                headerClasses: "",
                                headerGroupClasses: "",
                                groupable: false,
                                movable: true,
                                hidden: false,
                                dataType: "string",
                                hasSummary: false,
                                field: "status",
                                width: "150px",
                                header: "status",
                                resizable: true,
                                searchable: true,
                                selectable: true,
                                parent: null,
                                columnGroup: false,
                                disableHiding: false
                            };

                            resGridSettings.push(transObj);
                        }

                        if (!dealershipNameExists && userRole === "Director") {
                            const dealershipNameObj = {
                                pinned: false,
                                sortable: true,
                                filterable: true,
                                editable: false,
                                sortingIgnoreCase: true,
                                filteringIgnoreCase: true,
                                headerClasses: "",
                                headerGroupClasses: "",
                                groupable: false,
                                movable: true,
                                hidden: false,
                                dataType: "string",
                                hasSummary: false,
                                field: "dealershipName",
                                width: "150px",
                                header: "age",
                                resizable: true,
                                searchable: true,
                                selectable: true,
                                parent: null,
                                columnGroup: false,
                                disableHiding: false
                            };

                            resGridSettings.push(dealershipNameObj);
                        }

                        resGridSettings.forEach((element: { hidden: boolean; field: string; }) => {
                            //sending the values to array to the sidebar
                            arr1.push({ key: element.field, hidden: element.hidden })
                            if (element.hidden === true) {
                                setHiddenFields(prevHiddenFields => [...prevHiddenFields, element.field])
                            } else {
                                setVisibleFields(prevHiddenFields => [...prevHiddenFields, element.field])
                            }
                        });
                        Store.dispatch(setGridData(arr1));
                    }
                    let headerRes = await GetHeaderType('', parseInt(Did), 'getInventoryDate');
                    if (headerRes) {
                        var ls = new Date(headerRes.currentAsOf).toLocaleString().split(', ');
                        var thedate = new Date(Date.parse(ls[0] + " " + ls[1] + " " + "UTC"));
                        setInventoryDate(thedate.toLocaleString());
                    }
                    let res = await getVehicleReports(report, Did, false);
                    if (res.length === 0) {
                        return;
                    }
                    localStorage.setItem("scannedLotLocations", resMain.scannedLotLocations);
                    localStorage.setItem("statuses", resMain.statuses);
                    localStorage.setItem("lotLocations", resMain.lotLocations.sort());
                    localStorage.setItem("dealershipData", JSON.stringify(res[0].vehicles.dealership))
                    const storedDealershipName = sessionStorage.getItem('dealershipName');
                    // If dealershipName is not present in sessionStorage, set a default value
                    if (!storedDealershipName) {
                        const defaultDealershipName = res[0].vehicles.dealership.dealerShipName;
                        sessionStorage.setItem('dealershipName', defaultDealershipName);
                    }
                    const transformedArray = res.map((item: { gpsEnable: any; scanned: any; scannedDate: any; scannedLotLocation: any; vehicleStatus: any; vehicles: any; transmitted: boolean; }) => {
                        const { gpsEnable, scanned, scannedDate, scannedLotLocation, vehicleStatus, vehicles, transmitted } = item;

                        const today = new Date();
                        let ageInDays: any
                        if (vehicles.arrivalDate && vehicles.arrivalDate !== "0001-01-01T00:00:00") {
                            let dateToCalculate = new Date(vehicles.arrivalDate);
                            ageInDays = Math.floor((today.getTime() - dateToCalculate.getTime()) / (1000 * 3600 * 24));
                        } else if (vehicles.stockedInDate && vehicles.stockedInDate !== "0001-01-01T00:00:00") {
                            let dateToCalculate = new Date(vehicles.stockedInDate)
                            ageInDays = Math.floor((today.getTime() - dateToCalculate.getTime()) / (1000 * 3600 * 24));
                        } else {
                            ageInDays = ""
                        }

                        const returnObj = {
                            "Print": "",
                            ...vehicles,
                            "age": ageInDays,
                            gpsEnable,
                            scanned,
                            scannedDate,
                            scannedLotLocation,
                            vehicleStatus,
                            transmitted
                        };

                        if (userRole === "Director") {
                            returnObj.dealershipName = vehicles.dealership?.dealerShipName || "";
                        }

                        return returnObj;
                    })
                    if (resGridSettings === "Error") {
                        setData(transformedArray);
                        const defaultDisplay = ["Print", "lastKnownLocation", "stockNo", "type", "modelYear", "make", "model", "color", "vin", "arrivalDate", "retailPrice", "body", "miles", "trimLevel", "age", "lotLocation", "lastScanned", "vehicleStatus", "scannedLotLocation", "qRScannedCount"];

                        const gridSettings = transformedArray.reduce((acc: { [key: string]: boolean }, item: any) => {
                            Object.keys(item).forEach((key: string) => {
                                acc[key] = defaultDisplay.includes(key);
                            });
                            return acc;
                        }, {});

                        Store.dispatch(setGridData(Object.keys(gridSettings).map(key => ({ key, hidden: !gridSettings[key] }))));
                    } else {
                        window.dispatchEvent(new Event('gridSettings'))
                        let gridSettingsData = reOrderData(transformedArray, resGridSettings)
                        setData(gridSettingsData);

                        let headerWidthArray = resGridSettings.map((setting: { header: any; width: any; }) => ({
                            header: setting.header,
                            width: setting.width
                        }));

                        setWidthData(headerWidthArray)
                    }
                }
            }
        } catch (error: any) {
            console.error(error.message);
            setErrorCode(1)
            setErrorMessage(error.message);
            setIsLoading(false);
        } finally {
            alreadyFetched.current = false
            setIsLoading(false);
        }
    }, [Did, alreadyFetched, userName, vins, userRole, selectedDealership])

    const handelGetExtraData = useCallback(async (operation: string) => {
        setGridOperations('')
        setData([])
        let result: any
        let dataDisplay: any
        try {
            alreadyFetched.current = true
            if (operation === "userList") {
                result = await GetUsersList()
                dataDisplay = result.map((user: { userName: any; email: any; roleName: any; dealershipName: any; phoneNumber: any; tempPassword: any; enable: any; id: any; setVehicleScannedMenu: boolean }) => ({
                    'userName': user.userName,
                    'email': user.email,
                    'roleName': user.roleName,
                    'dealershipName': user.dealershipName,
                    'phoneNumber': user.phoneNumber,
                    'tempPassword': user.tempPassword,
                    'enable': user.enable,
                    'id': user.id,
                    'setVehicleScannedMenu': user.setVehicleScannedMenu
                }));
                setData(dataDisplay);
            } else if (operation === "vehicleStatus") {
                if (Did) {
                    result = await GetLotHistory(operation, Did)
                    if (result.length > 0) {
                        result = result.map((item: any, index: number) => ({ ...item, id: index + 1 }))
                        setData(result)
                    } else {
                        setData([{ statusID: "", status: "" }]);
                    }
                }
            } else if (operation === "uploadDMS") {
                result = await GetModal('POST', 'VehWizAPI/UpdateScannedVehicles', '')
                if (result === "") {
                    setErrorCode(0);
                    setErrorMessage('DMS Uploaded successfully');
                } else {
                    alert(result)
                }
            } else if (operation === 'endInventory') {
                if (Did) {
                    result = await GetHeaderType('', parseInt(Did), 'endInventory')
                    if (result === "\"Success\"") {
                        setErrorCode(0);
                        setErrorMessage('Inventory Stopped');
                        window.location.reload()
                    } else {
                        setErrorCode(1);
                        setErrorMessage('Failed to stop the inventory')
                    }
                }
            }
        } catch (error: any) {
            console.error(error.message);
            setErrorCode(1)
            setErrorMessage(error.message)
        } finally {
            alreadyFetched.current = false
        }
    }, [Did, alreadyFetched]);

    const handleLotHistory = useCallback((e: CustomEvent) => {
        const handleGetData = async (report: string, vin: string) => {
            if (vin && Did) {
                let res = await GetContextReport(Did, vin, report);
                if (!res) return;
                const transformedArray = res.map((item: any) => {
                    return {
                        "Print": "",
                        ...item,
                    }
                })
                setData(transformedArray)
            }
        }
        setReportType1("lotHistory");
        setData([]);
        handleGetData(e.detail.lotLocation, e.detail.vin)
    }, [Did]);

    const handleGetVinData = useCallback((e: CustomEvent) => {
        const handleGetData = async (vin: string) => {
            if (vin && Did) {
                let res = await GetVinNotes(vin, Did);
                if (!res) return;
                const transformedArray = res.map((item: any) => {
                    return {
                        "Print": "",
                        ...item,
                    }
                })
                setData(transformedArray)
            }
        }
        setReportType1(e.detail.vinNotes);
        setData([]);
        handleGetData(e.detail.vin)
    }, [Did]);

    const handleGetScanHistory = useCallback((e: CustomEvent) => {
        const handleGetData = async (vin: any) => {
            if (Did) {
                let res = await GetScanHistory(vin, Did);
                if (!res) return;
                const transformedArray = res.map((item: any) => {
                    return {
                        "Print": "",
                        ...item,
                    }
                })
                setData(transformedArray)
            }
        }
        setReportType1(e.detail.scanHistory);
        setData([]);
        handleGetData(e.detail.data)
    }, [Did])

    const handelGetUserDevices = async () => {
        setData([])
        if (Did) {
            try {
                let res = await GetUserDevices(Did)
                const mappedRes = res.map((item: any) => ({
                    ...item
                }));
                setData(mappedRes)
            } catch (err: any) {
                console.error(err.message);
                setErrorCode(1)
                setErrorMessage(err.message)
            } finally {
                alreadyFetched.current = false
            }
        }
    }

    const handleNewInventoryEvent = (event: CustomEvent) => {
        event.preventDefault()
        setModal(true)
        setTitle('Select Inventory')
    }

    const handleEndInventoryEvent = (event: CustomEvent) => {
        event.preventDefault()
        setModal(true);
        setTitle("End Inventory");
    }

    const handleDMSUploadEvent = useCallback((event: CustomEvent) => {
        event.preventDefault()
        handelGetExtraData('uploadDMS');
    }, [handelGetExtraData])

    async function handleGetSearchData(report: string, term: string) {
        if (report === "All Vehicles" || report === "Missing Vehicles" || report === "Extra Vehicles" || report === "Scanned Vehicles") {
            let res = await searchAPI(report, term);
            let resGridSettings: any;
            if (userName) {
                resGridSettings = await GridSettings(userName);
            }
            if (res.length > 0) {
                setData([])
                const transformedArray = res.map((item: { gpsEnable: any; scanned: any; scannedDate: any; scannedLotLocation: any; vehicleStatus: any; vehicles: any; transmitted: boolean }) => {
                    const { gpsEnable, scanned, scannedDate, scannedLotLocation, vehicleStatus, vehicles, transmitted } = item;

                    const today = new Date();
                    let ageInDays: any
                    if (vehicles.arrivalDate && vehicles.arrivalDate !== "0001-01-01T00:00:00") {
                        let dateToCalculate = new Date(vehicles.arrivalDate);
                        ageInDays = Math.floor((today.getTime() - dateToCalculate.getTime()) / (1000 * 3600 * 24));
                    } else if (vehicles.stockedInDate && vehicles.stockedInDate !== "0001-01-01T00:00:00") {
                        let dateToCalculate = new Date(vehicles.stockedInDate)
                        ageInDays = Math.floor((today.getTime() - dateToCalculate.getTime()) / (1000 * 3600 * 24));
                    } else {
                        ageInDays = ""
                    }

                    const returnObj = {
                        "Print": "",
                        ...vehicles,
                        "age": ageInDays,
                        gpsEnable,
                        scanned,
                        scannedDate,
                        scannedLotLocation,
                        vehicleStatus,
                        transmitted
                    };

                    // Add dealershipName if user is Director (same logic as initial load)
                    if (userRole === "Director") {
                        returnObj.dealershipName = vehicles.dealership?.dealerShipName || "";
                    }

                    return returnObj;
                })

                if (resGridSettings === "Error") {
                    setData(transformedArray);
                    const defaultDisplay = ["Print", "lastKnownLocation", "stockNo", "type", "modelYear", "make", "model", "color", "vin", "arrivalDate", "retailPrice", "body", "miles", "trimLevel", "age", "lotLocation", "lastScanned", "vehicleStatus", "scannedLotLocation", "qRScannedCount"];

                    const gridSettings = transformedArray.reduce((acc: { [key: string]: boolean }, item: any) => {
                        Object.keys(item).forEach((key: string) => {
                            acc[key] = defaultDisplay.includes(key);
                        });
                        return acc;
                    }, {});

                    Store.dispatch(setGridData(Object.keys(gridSettings).map(key => ({ key, hidden: !gridSettings[key] }))));
                } else {
                    resGridSettings = JSON.parse(resGridSettings);
                    let gridSettingsData = reOrderData(transformedArray, resGridSettings)
                    setData(gridSettingsData);

                    let headerWidthArray = resGridSettings.map((setting: { header: any; width: any; }) => ({
                        header: setting.header,
                        width: setting.width
                    }));

                    setWidthData(headerWidthArray);
                }

                // IMPORTANT: Set a flag to indicate this is search data
                // This will be used in componentDidUpdate to handle filter restoration differently
                setIsSearchData(true); // You'll need to add this state variable
            } else {
                setErrorCode(1);
                setErrorMessage("No such item exists in the grid");
            }
        } else {
            setErrorCode(1);
            setErrorMessage("Search is not available for this report");
        }
        clearSearchTerm();
    }

    // Effect 1: Handle dealership fetching (only when userName or userRole changes)
    useEffect(() => {
        const getAllDealerships = async () => {
            if (userName && (userRole === "Director" || userRole === 'Admin' || userRole === 'SuperUser')) {
                let res = await GetDealerships(userName);
                if (res) {
                    setDealerships([{ dealerID: "1", dealershipName: "All Dealerships" }, ...res])
                }
            }
        }

        getAllDealerships();
    }, [userName, userRole]);

    // Effect 2: Handle search operations
    useEffect(() => {
        if (searchTerm !== '') {
            handleGetSearchData(reportType1, searchTerm);
        }
    }, [searchTerm, reportType1]);

    // Effect 3: Handle selected dealership changes - but ONLY for All Vehicles reports
    useEffect(() => {
        if (selectedDealership.length > 0) {
            if(!reportType1) {
                fetchData("All Vehicles");
            }
            
            if (reportType1 === "All Vehicles" || reportType1 === "Missing Vehicles" || reportType1 === "Scanned Vehicles" || reportType1 === "Extra Vehicles") {
                fetchData(reportType1);
            }
        } 
    }, [selectedDealership, reportType1]); // Removed fetchData dependency to prevent loops

    // Effect 4: Initial load - fetch All Vehicles only once on component mount
    useEffect(() => {
        const shouldFetchAllVehicles = !hasFetchedAllVehicles.current;

        if (shouldFetchAllVehicles) {
            // Check for Director role requirements
            if (userRole === "Director" || userRole === 'Admin' || userRole === 'SuperUser') {
                const isDealershipEmpty = !selectedDealership ||
                    (Array.isArray(selectedDealership) && selectedDealership.length === 0);

                if (isDealershipEmpty && Did?.startsWith('-') && parseInt(Did) < 0) {
                    return;
                }
            }
            setReportType1("All Vehicles");
            fetchData('All Vehicles');
            hasFetchedAllVehicles.current = true;
        }
    }, []);

    // Effect 5: Handle event listeners
    useEffect(() => {
        const handleInventoryRefresh = () => {
            let reportFilter: string = '';
            switch (reportType1) {
                case 'Scanned Vehicles':
                    reportFilter = 'Scanned'
                    break;
                case 'Missing Vehicles':
                    reportFilter = 'Missing'
                    break;
                default:
                    reportFilter = reportType1
                    break;
            }
            fetchData(reportFilter);
        };

        // Add event listeners
        window.addEventListener("newInventory", handleNewInventoryEvent as EventListener);
        window.addEventListener("endInventory", handleEndInventoryEvent as EventListener);
        window.addEventListener("uploadDMS", handleDMSUploadEvent as EventListener);
        window.addEventListener("inventoryRefresh", handleInventoryRefresh as EventListener);
        window.addEventListener("LotHistory", handleLotHistory as EventListener);
        window.addEventListener("vinNotes", handleGetVinData as EventListener);
        window.addEventListener("scanHistory", handleGetScanHistory as EventListener);

        // Cleanup function
        return () => {
            window.removeEventListener("newInventory", handleNewInventoryEvent as EventListener);
            window.removeEventListener("endInventory", handleEndInventoryEvent as EventListener);
            window.removeEventListener("uploadDMS", handleDMSUploadEvent as EventListener);
            window.removeEventListener("inventoryRefresh", handleInventoryRefresh as EventListener);
            window.removeEventListener("LotHistory", handleLotHistory as EventListener);
            window.removeEventListener("vinNotes", handleGetVinData as EventListener);
            window.removeEventListener("scanHistory", handleGetScanHistory as EventListener);
        };
    }, [reportType1, fetchData, handleDMSUploadEvent, handleLotHistory, handleGetVinData, handleGetScanHistory]);

    const handleToggle: SidebarToggle = (isCollapsed) => {
        setCollapsed(isCollapsed);

        const sidebarWidth = isCollapsed ? 60 : 180;
        window.dispatchEvent(new CustomEvent('sidebarResize', {
            detail: { width: sidebarWidth, collapsed: isCollapsed }
        }));
    }

    const downloadFile = (driverName: any) => {
        const link = document.createElement("a");
        // if (driverName === "TSC") {
        //     link.href = "/assets/TSCDrivers.zip"
        // } else {
        //     link.href = "/assets/ZebraDrivers.zip"
        // }
        // link.download = driverName + '.zip';
        link.href = '/assets/jspm7-7.0.0.0-win.exe';
        link.download = 'JSPM7.0' + '.exe';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link)
    }

    const handleMenuSelected = async (isSelected: string) => {
        if (userRole === "Director" && !selectedDealership) {
            setErrorCode(1);
            setErrorMessage("Please select a dealer to view the report");
            return;
        }

        switch (isSelected) {
            case "All Vehicles":
                setReportType1('All Vehicles');
                fetchData('All Vehicles');
                break;

            case "Report Missing":
                setReportType1('Missing Vehicles');
                fetchData('Missing');
                break;

            case "Report Scanned":
                setReportType1('Scanned Vehicles');
                fetchData('Scanned');
                break;

            case "Report-Extra Vehicles":
                setReportType1('Extra Vehicles');
                fetchData('Extra Vehicles');
                setShowAddButton(true);
                break;

            case "Report Summary":
                setModal(true);
                setTitle(isSelected);
                alreadyFetched.current = true;
                break;

            case "Lot History":
                setReportType1("lotHistory");
                fetchData('lotHistory');
                break;

            case "Scanned Vehicle Notes":
                setReportType1("scannedVehicleNotes");
                fetchData("scannedVehicleNotes");
                setShowAddButton(true);
                break;

            case "User Devices":
                handelGetUserDevices();
                setReportType1("User Devices");
                break;

            case "DMS Connectivity":
                setModal(true);
                setTitle(isSelected);
                break;

            case "Label Config":
                setModal(true);
                setTitle("Label Request Information");
                break;

            case "Preferences":
                setModal(true);
                setTitle("Preferences");
                break;

            case "Download Label Print Support":
                downloadFile('');
                break;

            case "User List":
                handelGetExtraData("userList");
                setReportType1("userList");
                setShowAddButton(true);
                break;

            case "Enable QR-Code":
                setModal(true);
                setTitle("Enable QR-Code");
                break;

            case "Manage Vehicle Status":
                handelGetExtraData("vehicleStatus");
                setReportType1("vehicleStatus");
                setShowAddButton(true);
                break;

            case "CSV Files For FileBased":
                window.location.href = '/dashboard/filebasedDMS';
                break;

            case "Save grid settings":
                window.dispatchEvent(new Event('saveGrid'));
                break;

            case "Clear grid settings":
                window.dispatchEvent(new Event('clearGrid'));
                break;

            case "Column Selector":
                if (reportType1 === "All Vehicles" || reportType1 === "Missing Vehicles" || reportType1 === "Scanned Vehicles") {
                    setModal(true);
                    setTitle("columnChooser");
                } else {
                    setErrorCode(1);
                    setErrorMessage("This feature is only available for vehicle reports");
                }
                break;

            case "User Instructions":
                window.open("http://academy.scansolutions.com/", "_blank");
                return;

            case "Request Remote Support":
                window.open("https://scansolutions.screenconnect.com/", "_blank");
                return;

            case "Order Labels":
                window.open("https://scansolutions.com/label-order.html", "_blank");
                break;

            case "Print Labels":
                setGridOperations('printLabels');
                break;

            case "Print Report":
                window.dispatchEvent(new Event("printReport"));
                break;

            case "Recent Downloads":
                setModal(true);
                setTitle("Recent Downloads");
                break;

            case "Export Data":
                setGridOperations("Export");
                break;

            case "Vehicle Accessory":
                setReportType1("accessory");
                fetchData("accessory");
                setShowAddButton(true);
                break;

            case "Beacon - Keys":
                setReportType1('getBeaconKeys');
                fetchData('getBeaconKeys');
                break;

            case "Beacon - Vehicles":
                setReportType1('getBeaconVehicles');
                fetchData('getBeaconVehicles');
                break;

            case "Report - For Vehicles":
                setReportType1('beaconVehiclesReport');
                fetchData('beaconVehiclesReport');
                break;

            case "Report - For Keys":
                setReportType1('beaconKeysReport');
                fetchData('beaconKeysReport');
                break;

            default:
                setReportType1('All Vehicles');
                fetchData('All Vehicles');
                break;
        }
    };

    const handelAlertChange = (errCode: number, errMsg: string, status: string) => {
        setErrorCode(errCode)
        setErrorMessage(errMsg)
        if (status === "Success" || status === "Info") {
            if (title === "scanVehicles") {
                window.location.reload();
            }
            setModal(!modal)
        }
    }

    const handelRowHide = (hiddenData: any) => {
        setHiddenData(hiddenData)
    }

    const handleClose = () => {
        setErrorCode(undefined);
        setErrorMessage('');
    }

    const reOrderData = (apiData: any[], settingsData: any) => {
        const GridSettingsData = settingsData;
        const GridSettingsKeyOrder = GridSettingsData.map((item: { field: any; }) => item.field);

        const reorderedData = apiData.map(data => {
            const newObject: Record<string, any> = {};

            GridSettingsKeyOrder.forEach((key: string) => {
                newObject[key] = data[key];
            });

            return newObject;
        });

        return reorderedData;
    }

    const clearOperationState = () => {
        setGridOperations('')
    }

    const handleAddClicked = () => {
        window.dispatchEvent(new Event('addNewRow'));
    }

    const handleDealershipChange = (selectedList: { dealerID: string; dealershipName: string }[]) => {
        const allDealershipsSelected = selectedList.some(dealer => dealer.dealerID === "1");

        let selectedIds: string[];
        if (allDealershipsSelected) {
            const allDealerships = dealerships.filter(dealer => dealer.dealerID !== "1");
            setSelectedTemporaryDealership(allDealerships);
            selectedIds = allDealerships.map(dealer => dealer.dealerID);
        } else {
            setSelectedTemporaryDealership(selectedList);
            selectedIds = selectedList.map(dealer => dealer.dealerID);
        }
    };

    const handleApplyPress = () => {
        if (selectedTemporaryDealership) {
            setSelectedDealership(selectedTemporaryDealership);
            let ids = selectedTemporaryDealership.map(dealer => dealer.dealerID);
            sessionStorage.setItem("dealerId", ids.join(","));
        }
    }

    const handleclearAllSelected = () => {
        setSelectedDealership([]);
        sessionStorage.setItem("dealerId", '');
    }

    return (
        <div className="flex h-full bg-gray-100">
            <div className={collapsed ? 'collapsed h-auto' : 'h-auto'}>
                <SideBar onToggle={handleToggle} onMenuSelected={handleMenuSelected} />
            </div>
            <div className="overflow-hidden w-full">
                <div className="pt-2 pb-2 flex justify-between items-center">
                    <div className="flex justify-start items-start pl-3">
                        {reportType1 === 'All Vehicles' || reportType1 === 'Missing Vehicles' || reportType1 === 'Extra Vehicles' || reportType1 === 'Scanned Vehicles' ? (
                            <p className="text-pantone-grey headerText drop-shadow-md"><span className="text-lg">Current Report: <u><b>{reportType1}</b></u></span> | <span className="text-lg">Inventory current as of: {inventoryDate ? inventoryDate : 'not downloaded'}</span></p>
                        ) : null}
                    </div>
                    <div className="mr-4">
                        {(userRole === 'Director' || userRole === 'Admin' || userRole === 'SuperUser') && (
                            <div className="flex justify-between items-center">
                                <Multiselect
                                    options={dealerships}
                                    selectedValues={selectedDealership}
                                    onSelect={handleDealershipChange}
                                    onRemove={handleDealershipChange}
                                    showCheckbox
                                    displayValue="dealershipName"
                                    className="text-graphite multiselect-container"
                                    placeholder="Select Dealerships" />

                                <button onClick={handleApplyPress} className="pl-3 text-graphite">Apply</button>
                                <button onClick={handleclearAllSelected} className="pl-3 text-graphite">Clear</button>
                            </div>
                        )}
                    </div>
                </div>
                <div className="p-3">
                    <div className="w-full rounded-md" style={{ fontFamily: 'Montserrat' }}>
                        {showAddButton && (reportType1 === "userList" || reportType1 === "accessory" || reportType1 === "scannedVehicleNotes" || reportType1 === "vehicleStatus" || reportType1 === "Extra Vehicles") ? (
                            <div className="pb-2">
                                <button className="button-6" onClick={handleAddClicked}>Add Row</button>
                            </div>
                        ) : null}
                        <div className="relative">
                            {isLoading && (
                                <div className="absolute inset-0 bg-white bg-opacity-70 flex justify-center items-center z-10">
                                    <div className="animate-spin rounded-full h-10 w-10 border-t-2 border-blue-500"></div>
                                </div>
                            )}
                            <IgniteGrid data={data} report={reportType1} hiddenData={hiddenFields} visibleData={visibleFields} headerOps={reportType} dataHidden={hiddenData} operation={gridOperations} clearOperation={clearOperationState} colWidth={widthData} isSearchData={isSearchData} />
                        </div>
                    </div>
                    <div style={{ zIndex: 10 }}>
                        <CommonModal isOpen={modal} title={title} onAlert={handelAlertChange} onClose={() => setModal(false)} onHideData={handelRowHide} />
                    </div>
                </div>
            </div>
            {errorCode ? (
                <div className="absolute top-0 right-0">
                    <Alert code={errorCode} message={errorMessage} onClose={handleClose} />
                </div>
            ) : null}
        </div>
    )
}

export default Dashboard